export const boats = [
  {
    id: 1,
    name: 'CARLA',
    model: 'Bayliner 3055 Ciera',
    type: 'Motorboat',
    length: '9.3m',
    width: '3.05m',
    capacity: 8,
    berths: 4,
    skipperBerth: false,
    engine: '260 HP Diesel',
    fuelConsumption: '15 liters/hour',
    skipperRequired: false,
    pricePerDay: 490,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/7a5c2446233c8b6fe2dd55d15dd740ff.png',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/7a5c2446233c8b6fe2dd55d15dd740ff.png',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/95f92fe555d67cdf514073818aba18df.png',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/86b46ba92b757fc1c398e7d3bf0810e9.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/679e03dddfdf2a101e71d3dafd35c62a.jpeg'
    ],
    description: 'Perfect for day trips and coastal exploration. CARLA offers comfort and performance for groups up to 8 people. Ideal for discovering the beautiful bays and islands of the French Riviera.',
    features: [
      'Cabin with berths',
      'Bathroom',
      'Equipped galley',
      'Sundeck',
      'Swimming platform',
      'Bluetooth audio system',
      'GPS navigation',
      'Safety equipment'
    ]
  },
  {
    id: 2,
    name: 'MAMILIPP III',
    model: 'Astondoa 49 GL',
    type: 'Luxury Motorboat',
    length: '14.75m',
    width: '4.35m',
    capacity: 12,
    berths: 6,
    skipperBerth: true,
    engine: '2 × 485 HP Diesel',
    fuelConsumption: '90 liters/hour',
    skipperRequired: true,
    pricePerDay: 1490,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/66f9e028a14bac576ecdf9a5df69b1b6.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/66f9e028a14bac576ecdf9a5df69b1b6.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/67189c06d2b5f8608cfc6a0ad8c64854.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/b2a2b8a6a931df2a98fcd5019257eb38.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c829b798d4efe1f89dd195f9359878bc.jpeg'
    ],
    description: 'Experience luxury on the Mediterranean with MAMILIPP III. This premium yacht comes with an experienced skipper to ensure your comfort and safety while exploring the most beautiful spots of the French Riviera.',
    features: [
      'Spacious flybridge',
      'Full galley',
      'Air conditioning',
      'Premium sound system',
      'Large sundeck',
      'Outdoor dining',
      'Water toys',
      'Professional skipper'
    ]
  }
];
